import React, { useState } from 'react';
import { Container, Paper, Box, Typography, Link, Divider } from '@mui/material';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import Header from '../Layout/Header';
import KeyVisual from './KeyVisual';

const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleMode = () => {
    setIsLogin(!isLogin);
  };

  return (
    <Box>
      <Header />
      <Container component="main" maxWidth="md">
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'stretch',
            gap: 4,
          }}
        >
          {/* キービジュアル */}
          <Box sx={{ flex: { xs: 'none', md: 1 } }}>
            <KeyVisual />
          </Box>
          
          {/* ログイン/登録フォーム */}
          <Box sx={{ flex: { xs: 'none', md: '0 0 400px' } }}>
            <Paper elevation={3} sx={{ padding: 4, height: 'fit-content' }}>
              {isLogin ? (
                <LoginForm onToggleMode={toggleMode} />
              ) : (
                <RegisterForm onToggleMode={toggleMode} />
              )}
            </Paper>
          </Box>
        </Box>
        
        {/* フッター */}
        <Box 
          component="footer" 
          sx={{ 
            mt: 6, 
            py: 3, 
            textAlign: 'center',
            borderTop: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            © 2024 DeckWin. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Link 
              href="/privacy-policy" 
              target="_blank" 
              color="primary" 
              variant="body2"
              sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              プライバシーポリシー
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link 
              href="/terms-of-service" 
              target="_blank"
              color="primary" 
              variant="body2"
              sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              利用規約
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link 
              href="/contact" 
              target="_blank"
              color="primary" 
              variant="body2"
              sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              お問い合わせ
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AuthPage;